<template>
  <div id="cardContentRayonX">
    <div class="mt-3">
      Votre niveau de risque :
    </div>
    <div class="mt-3">
      Vous avez une probabilité de {{ Math.round(risks.P_21_005*10000)/100}} % de perdre au moins 5% sur 1 mois
      <img src="./étoiles.png" alt="cardContentrayonXetoiles" />
    </div>
    <!-- <div class="mt-3">
      Economie potentielle : 200€ / an Soit un gain de 12 546 e sur 20 ans
    </div> -->
    <div class="mt-3">
      <b-button href="/scan/diagnostic/risks" class="btnCardContent">
        Analyser en détail mon risque
      </b-button>
    </div>
  </div>
</template>
<script>
export default {
  props: ["risks"],
};
</script>
